"use strict";
/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditorEvents = void 0;
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const eventEmitter = new eventemitter3_1.default();
exports.EditorEvents = {
    emit: (event, payload) => eventEmitter.emit(event, payload),
    off: (event) => eventEmitter.off(event),
    on: (event, fn) => eventEmitter.on(event, fn),
};
Object.freeze(exports.EditorEvents);
